import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="grouped-items"
export default class extends Controller {
  connect() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll);
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const scrollButton = document.getElementById("scroll-up-button");
    if (window.scrollY > 0) {
      scrollButton.classList.remove("hidden");
    } else {
      scrollButton.classList.add("hidden");
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  scrollToSection(event) {
    event.preventDefault();
    const char = event.currentTarget.dataset.char;
    const sectionId = `section-${char}`;
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth" });
    }
  }
}
